/* Reels Testimonials — Dua Pixels
   - one video plays at a time (the centred card)
   - src is attached only to the active card and its immediate neighbours
   - auto-advance, pausable, respects reduced motion
*/
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initRoot(root) {
    if (root.dataset.reelsReady === '1') return;
    root.dataset.reelsReady = '1';

    var track = root.querySelector('[data-reels-track]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-reel-card]'));
    if (!track || !cards.length) return;

    var toggleBtn = root.querySelector('[data-reels-toggle]');
    var toggleText = root.querySelector('[data-reels-toggle-text]');
    var prevBtn = root.querySelector('[data-reels-prev]');
    var nextBtn = root.querySelector('[data-reels-next]');
    var status = root.querySelector('[data-reels-status]');

    var interval = parseInt(root.dataset.interval, 10) || 4000;
    var wantsAuto = root.dataset.autoscroll === 'true' && !REDUCED;

    var activeIndex = -1;
    var inView = false;
    var userPaused = false;
    var timer = null;
    var resumeTimer = null;
    var ticking = false;

    /* ---------- video helpers ---------- */

    function videoOf(card) {
      return card.querySelector('.reel-video');
    }

    function hydrate(card) {
      var v = videoOf(card);
      if (!v || !v.dataset.src) return;
      if (!v.getAttribute('src')) {
        v.setAttribute('src', v.dataset.src);
        v.load();
      }
    }

    function dehydrate(card) {
      var v = videoOf(card);
      if (!v) return;
      try {
        v.pause();
      } catch (e) {}
      if (v.getAttribute('src')) {
        v.removeAttribute('src');
        v.load();
      }
    }

    function pauseAll(except) {
      cards.forEach(function (card) {
        var v = videoOf(card);
        if (!v || v === except) return;
        try {
          v.pause();
          v.currentTime = 0;
        } catch (e) {}
      });
    }

    function playActive() {
      if (activeIndex < 0 || !inView || REDUCED) return;
      var v = videoOf(cards[activeIndex]);
      if (!v || !v.getAttribute('src')) return;
      var p = v.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () {
          /* autoplay refused — poster stays, nothing to report */
        });
      }
    }

    /* ---------- active card ---------- */

    function setActive(index) {
      if (index === activeIndex || index < 0 || index >= cards.length) return;
      activeIndex = index;

      cards.forEach(function (card, i) {
        var isActive = i === index;
        card.classList.toggle('is-active', isActive);

        if (Math.abs(i - index) <= 1) {
          hydrate(card);
        } else {
          dehydrate(card);
        }
      });

      pauseAll(videoOf(cards[index]));
      playActive();

      if (status) {
        status.textContent = 'Testimonial ' + (index + 1) + ' of ' + cards.length;
      }
    }

    function nearestIndex() {
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0;
      var bestDist = Infinity;
      cards.forEach(function (card, i) {
        var centre = card.offsetLeft + card.offsetWidth / 2;
        var d = Math.abs(centre - mid);
        if (d < bestDist) {
          bestDist = d;
          best = i;
        }
      });
      return best;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        setActive(nearestIndex());
        ticking = false;
      });
    }

    function goTo(index) {
      var i = (index + cards.length) % cards.length;
      var card = cards[i];
      var left = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
      track.scrollTo({ left: left, behavior: REDUCED ? 'auto' : 'smooth' });
      setActive(i);
    }

    /* ---------- auto-advance ---------- */

    function canRun() {
      return wantsAuto && inView && !userPaused && document.visibilityState === 'visible';
    }

    function start() {
      stop();
      if (!canRun()) return;
      timer = window.setInterval(function () {
        if (!canRun()) {
          stop();
          return;
        }
        goTo(activeIndex + 1);
      }, interval);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function holdThenResume() {
      stop();
      if (resumeTimer) window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(start, 8000);
    }

    /* ---------- events ---------- */

    track.addEventListener('scroll', onScroll, { passive: true });

    track.addEventListener('mouseenter', stop);
    track.addEventListener('mouseleave', start);
    track.addEventListener('touchstart', holdThenResume, { passive: true });
    track.addEventListener('wheel', holdThenResume, { passive: true });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        goTo(activeIndex + 1);
        holdThenResume();
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        goTo(activeIndex - 1);
        holdThenResume();
      }
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(activeIndex - 1);
        holdThenResume();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(activeIndex + 1);
        holdThenResume();
      });
    }

    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        userPaused = !userPaused;
        toggleBtn.setAttribute('aria-pressed', String(userPaused));
        if (toggleText) toggleText.textContent = userPaused ? 'Play' : 'Pause';
        toggleBtn.setAttribute('aria-label', userPaused ? 'Resume testimonials' : 'Pause testimonials');

        if (userPaused) {
          stop();
          var v = videoOf(cards[activeIndex]);
          if (v) {
            try {
              v.pause();
            } catch (e) {}
          }
        } else {
          playActive();
          start();
        }
      });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        playActive();
        start();
      } else {
        stop();
        pauseAll(null);
      }
    });

    /* Only wake the section up once it is actually on screen */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            inView = entry.isIntersecting;
            if (inView) {
              if (activeIndex < 0) setActive(nearestIndex());
              playActive();
              start();
            } else {
              stop();
              pauseAll(null);
            }
          });
        },
        { threshold: 0.25 }
      ).observe(root);
    } else {
      inView = true;
      setActive(0);
      start();
    }
  }

  function init() {
    document.querySelectorAll('[data-reels-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
